<template>
  <b-modal @hide="modalClose" ref="productModal" :title="$t('基本情報')" size="xl">
    <b-container fluid>
      <table class="table table-bordered my-3">
        <tbody class="tbody">
          <tr class>
            <th class="table-active text-left">{{ $t('製品種別') }}</th>
            <td class="text-left" colspan="3">
              <div class="form-check form-check-inline">
                <input
                  v-model="form.type"
                  class="form-check-input"
                  type="radio"
                  id="type1"
                  value="ownbrand"
                />
                <label class="form-check-label" for="type1">{{ $t("内製品") }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="form.type"
                  class="form-check-input"
                  type="radio"
                  id="type2"
                  value="purchase"
                />
                <label class="form-check-label" for="type2">{{ $t("仕入品") }}</label>
              </div>
              <div class="form-check form-check-inline">
                <input v-model="form.type"
                class="form-check-input"
                type="radio" id="type3" value="material">
                <label class="form-check-label" for="type3">
                {{ $t("材料") }}
                </label>
              </div>
            </td>
            <th class="table-active text-left">{{ $t('登録日') }}</th>
            <td class="text-left">
              <div class="row">
                <div class="col-md-12">
                  <div class="input-group w-100">
                    <date-picker v-model="form.registerDate" :config="datepicker.options" class="calendar"></date-picker>
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <font-awesome-icon :icon="['far', 'calendar-alt']" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <th class="table-active text-left" width="160">
              <template v-if="form.type === 'material'">
                {{ $t('材料コード') }}
              </template>
              <template v-else>
                {{ $t('品番') }}
              </template>
            <span class="text-danger">&nbsp;{{ $t("※必須") }}</span></th>
            <td class="text-left" width="200">
              <input v-model="form.code" type="text" class="form-control" />
            </td>
            <th  class="table-active text-left" width="160">{{ $t('改訂') }}</th>
            <td class="text-left" width="200">
              <input v-model="form.version" type="text" class="form-control" />
            </td>
            <th class="table-active text-left" width="160">
              <template v-if="form.type === 'material'">
                {{ $t('材料名/材質') }}
              </template>
              <template v-else>
                {{ $t('品名') }}
              </template>
            </th>
            <td class="text-left" width="200">
              <input v-model="form.name" type="text" class="form-control" />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">
              {{ $t('図番') }}
            </th>
            <td class="text-left">
              <input v-model="form.figureNo" type="text" class="form-control" />
            </td>
            <th class="table-active text-left">{{ $t('単位') }}</th>
            <td class="text-left">
              <input v-model="form.outputLevel" type="text" class="form-control" />
            </td>
            <th class="table-active text-left">{{ $t('RoHS指令対応') }}</th>
            <td class="text-left maw-6">
              <input v-model="form.isRoHS" type="checkbox" class="checkbox" style="transform:scale(1.4)" />
            </td>
          </tr>
        <tr>
          <template v-if="form.type === 'material' || form.type === 'purchase' ">
              <th class="table-active text-left">{{ $t('メーカー') }}</th>
              <td class="text-left">
                <input v-model="form.supplier" type="text" class="form-control" />
              </td>
          </template>
          <template v-if="form.type === 'material'">
            <th class="table-active text-left">{{ $t('基準手配リードタイム') }}</th>
            <td class="text-left">
              <div class="input-group w-100">
                <input v-model.number="form.materialLeadTime" type="number" min="0" class="form-control input">
                <div class="input-group-append">
                  <span class="input-group-text">
                    {{ $t('日') }}
                  </span>
                </div>
              </div>
            </td>
          </template>
        </tr>
          <tr v-if="form.type !== 'material'">
            <th class="table-active text-left">
              {{ $t('自由記述項目1') }}
            </th>
            <td class="text-left">
              <input v-model="form.freeText1" type="text" class="form-control" />
            </td>
            <th class="table-active text-left">
              {{ $t('自由記述項目2') }}
            </th>
            <td class="text-left">
              <input v-model="form.freeText2" type="text" class="form-control" />
            </td>
            <th class="table-active text-left">
              {{ $t('自由記述項目3') }}
            </th>
            <td class="text-left">
              <input v-model="form.freeText3" type="text" class="form-control" />
            </td>
          </tr>
          <tr v-if="form.type !== 'material'">
            <th class="table-active text-left">
              {{ $t('自由記述項目4') }}
            </th>
            <td class="text-left">
              <input v-model="form.freeText4" type="text" class="form-control" />
            </td>
            <th class="table-active text-left">
              {{ $t('自由記述項目5') }}
            </th>
            <td class="text-left">
              <input v-model="form.freeText5" type="text" class="form-control" />
            </td>
            <th class="table-active text-left">
              {{ $t('自由記述項目6') }}
            </th>
            <td class="text-left">
              <input v-model="form.freeText6" type="text" class="form-control" />
            </td>
          </tr>
          <tr v-if="form.type !== 'material'">
            <th class="table-active text-left">
              {{ $t('自由記述項目7') }}
            </th>
            <td colspan="99">
              <input v-model="form.freeText7" type="text" class="form-control" />
            </td>
          </tr>

          <tr v-if="form.type !== 'material'">
            <th class="table-active text-left">
              {{ $t('自由記述項目8') }}
            </th>
            <td colspan="99">
              <input v-model="form.freeText8" type="text" class="form-control" />
            </td>
          </tr>
          <tr v-if="form.type !== 'material'">
            <th class="table-active text-left">
              {{ $t('自由記述項目9') }}
            </th>
            <td colspan="99">
              <input v-model="form.freeText9" type="text" class="form-control" />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('備考') }}</th>
            <td colspan="99"><input v-model="form.note" type="text" class="form-control" /></td>
          </tr>
        </tbody>
      </table>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="error">{{ error }}</p>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          :disabled="registering"
          @click="register()"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="registering"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t('登録') }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          :disabled="registering"
          @click="modalClose()"
        >{{ $t('キャンセル') }}</button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'


const formSetting = {
  type: {type: 'string'},
  registerDate: {type: 'date'},
  code: {type: 'string'},
  name: {type: 'string'},
  figureNo: {type: 'string'},
  version: {type: 'string'},
  isRoHS: {type: 'boolean'},
  supplier: {type: 'string'},
  outputLevel: {type: 'string'},
  materialLeadTime: {type: 'number'},
  salesPrice: {type: 'number'},
  purchasePrice: {type: 'number'},
  shapeType: {type: 'string'},
  shapeValues: {type: 'array'},
  shapeWeight: {type: 'number'},
  note: {type: 'string'},
  shapeNote: {type: 'string'},
  freeText1: {type: 'string'},
  freeText2: {type: 'string'},
  freeText3: {type: 'string'},
  freeText4: {type: 'string'},
  freeText5: {type: 'string'},
  freeText6: {type: 'string'},
  freeText7: {type: 'string'},
  freeText8: {type: 'string'},
  freeText9: {type: 'string'},
  kana: {type: 'string'},
  material: {type: 'object'},
  priceNote: {type: 'string'},
}

export default {
  data() {
    return {
      form: {},
      error: '',
      registering: false,
    }
  },
  methods: {
    // モーダルを開いたときの処理
    modalOpen(item) {
      this.$refs.productModal.show()
      this.form = this.mixin_deepcopy(item)
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.$emit('modalClose')
      this.$refs.productModal.hide()
    },
    async register() {
      if (!this.form.code) return this.error = this.$t('品番') + this.$t('必須メッセージ')
      this.registering = true
      let params = {}
      for (let key of Object.keys(this.form)) {
        if (
          key === 'salesPrice' ||
          key === 'purchasePrice' ||
          key === 'shapeType' ||
          key === 'shapeValues' ||
          key === 'weight'
        ) {
          continue
        }
        if (formSetting[key] && formSetting[key].type === 'string') {
          params[key] = this.form[key] || ''
        } else if (this.form[key] !== null && this.form[key] !== undefined) {
          params[key] = this.form[key]
        }
      }
      for (let key of Object.keys(this.form)) {
        if (key !== 'salesPrice' && key !== 'purchasePrice' && key !== 'shapeType' && key !== 'shapeValues' && key !== 'weight' && this.form[key]) params[key] = this.form[key]
      }
      if (this.form.registerDate && this.form.registerDate !== '') {
        params.registerDate = this.form.registerDate.replaceAll('/', '-')
      }
      try {
        await this.$axios({
          method: 'put',
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/product`,
          data: params,
        })
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.$emit('registered')
        this.$refs.productModal.hide()
      } catch (error) {
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
      }
      this.registering = false
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>

<style lang="scss" scoped>
.maw-6 {
  max-width: 6rem;
}
</style>
